import React from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions} from "@material-ui/core";
//import {useSelector} from "react-redux";
//import {applicationSelector} from "../../redux/application";
import {makeStyles} from '@material-ui/core/styles';

// const useStyles = makeStyles((theme) => ({
//   title: {
//     background: theme.palette.primary.main,
//     color: 'white'
//   }
// }));


export default function DialogAdapter({open, title, content, actions, maxWidth="md", ...rest}) {


  //const styles = useStyles();
  //const {isModalDlgOpened} = useSelector(applicationSelector);

  return (<Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth={maxWidth}
      aria-labelledby="dialog-title"
      open={open}
      fullWidth={true}
      {...rest}
    >
      <DialogTitle id="dialog-title">{title}</DialogTitle>
      <DialogContent dividers>
        {content}
      </DialogContent>
      <DialogActions>
        {actions}
      </DialogActions>
    </Dialog>
  );

}